import api from './api';

const notificationService = {
  getMyNotifications: async ({ unread = false } = {}) => {
    const response = await api.get('/notifications', {
      params: unread ? { unread: true } : {}
    });
    return response.data;
  },

  markAsRead: async (id) => {
    const response = await api.post(`/notifications/${id}/read`);
    return response.data;
  },

  markAllAsRead: async () => {
    const response = await api.post('/notifications/read-all');
    return response.data;
  }
};

export default notificationService;


